import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "searches",
  "use": "searches-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"searches\">\n<title></title>\n<g id=\"searches_icomoon-ignore\">\n</g>\n<path d=\"M938.667 1024h-853.333v-768h853.333v768zM170.667 938.667h682.667v-597.333h-682.667v597.333z\" />\n<path d=\"M170.667 129.707h682.667v85.333h-682.667v-85.333z\" />\n<path d=\"M296.96 0h426.667v85.333h-426.667v-85.333z\" />\n<path d=\"M727.040 641.707h-430.080v-170.667h88.747v81.92h252.587v-81.92h88.747z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol